var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',{attrs:{"with_go_back_bar":""}},[(_vm.$can('read', 'open-banking'))?_c('manage-application-details'):(_vm.is_authenticated)?_c('common-application-details'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }